// src/components/Header.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/header.css';
import reanimeitorBanner from '../Assets/reanimeitor-banner-removebg-preview.png';
import supporticon from '../Assets/soporte.png';


const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

useEffect(() => {
  const checkAuthStatus = () => {
    const token = localStorage.getItem('userToken');
    const user = localStorage.getItem('userData');
    
    if (token && user) {
      setIsLoggedIn(true);
      setUserData(JSON.parse(user));
    } else {
      setIsLoggedIn(false);
      setUserData(null);
    }
  };

  // Verificar al montar el componente
  checkAuthStatus();

  // Escuchar cambios en localStorage
  const handleStorageChange = () => {
    checkAuthStatus();
  };

  window.addEventListener('storage', handleStorageChange);
  
  // También escuchar eventos personalizados
  window.addEventListener('authChange', handleStorageChange);

  return () => {
    window.removeEventListener('storage', handleStorageChange);
    window.removeEventListener('authChange', handleStorageChange);
  };
}, []);
  const handleLogout = () => {
    // Limpiar localStorage
    localStorage.removeItem('userToken');
    localStorage.removeItem('userData');
    
    // Actualizar estado
    setIsLoggedIn(false);
    setUserData(null);
    
    // Cerrar menú móvil si está abierto
    setIsMenuOpen(false);
    
    // Redirigir al home
    navigate("/");
  };

  const handleMobileLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo con imagen */}
        <div className="logo">
          <Link to="/" className="logo-link">
            <img 
              src={reanimeitorBanner} 
              alt="Reanimeitor" 
              className="logo-image"
            />
          </Link>
        </div>

        {/* Navegación Desktop */}
        <nav className="nav-desktop">
          <Link to="/" className="nav-link">Inicio</Link>
          <Link to="/about" className="nav-link">Nosotros</Link>
          <a href="/blog" className="nav-link">Blog</a>
        </nav>

   {/* Acciones de Usuario */}
<div className="user-actions">
  {/* Icono de soporte SIEMPRE visible */}
  <a href="/soporte" className="nav-link support-icon">
    <img 
      src={supporticon} 
      alt="Soporte" 
      className="logo-image"
    />
  </a>
  
  {/* Menú de usuario en desktop */}
  <div className="desktop-menu">
    {isLoggedIn ? (
      <div className="user-menu">
        <Link to="/account" className="nav-link account-link">
          👤
          {userData?.name && (
            <span className="user-name">({userData.name})</span>
          )}
        </Link>
        {window.location.pathname === '/account' && (
          <button 
            onClick={handleLogout} 
            className="logout-btn"
          >
            Cerrar Sesión
          </button>
        )}
      </div>
    ) : (
      <Link to="/login" className="login-btn">Únete</Link>
    )}
  </div>
  
  {/* Botón menú móvil */}
  <button 
    className="menu-toggle"
    onClick={() => setIsMenuOpen(!isMenuOpen)}
    aria-label="Menú"
  >
    ☰
  </button>
</div>
      </div>

      {/* Menú Mobile */}
      {isMenuOpen && (
        <nav className="nav-mobile">
          <Link to="/" className="nav-link" onClick={handleMobileLinkClick}>Inicio</Link>
          <Link to="/about" className="nav-link" onClick={handleMobileLinkClick}>Nosotros</Link>
          <a href="/blog" className="nav-link" onClick={handleMobileLinkClick}>Blog</a>
          
         {isLoggedIn ? (
  <>
    <Link to="/account" className="nav-link" onClick={handleMobileLinkClick}>
      👤 Mi Cuenta
    </Link>
    {/* Botón de cerrar sesión SOLO en AccountPage para móvil */}
    {window.location.pathname === '/account' && (
      <button 
        onClick={() => {
          handleLogout();
          handleMobileLinkClick();
        }} 
        className="nav-link logout-btn-mobile"
      >
        🚪 Cerrar Sesión
      </button>
    )}
  </>
) : (
  <Link to="/login" className="nav-link" onClick={handleMobileLinkClick}>Únete</Link>
)}
        </nav>
      )}
    </header>
  );
};

export default Header;